import React from 'react';
import { Box } from '@mui/material';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import colors from 'src/utils/colors';

interface LibraryErrorStateProps {
  onRetry: () => void;
}

export const LibraryErrorState: React.FC<LibraryErrorStateProps> = ({ onRetry }) => {
  return (
    <Box sx={{ textAlign: 'center', padding: '40px' }}>
      <Text variant="body1" sx={{ color: colors.grey, marginBottom: '16px' }}>
        Error loading library data
      </Text>
      <SlButton variant="contained" onClick={onRetry}>
        Retry
      </SlButton>
    </Box>
  );
};
